import BeforeAfterBetweenNumbers from "../../components/Nursery/Mathematics/BeforeAfterBetweenNumbers";
import CircleCorrectNumber from "../../components/Nursery/Mathematics/CircleCorrectNumber";
import CircleLargerObject from "../../components/Nursery/Mathematics/CircleLargerObject";
import CountObject from "../../components/Nursery/Mathematics/CountObject";
import MatchObjectWithNumber from "../../components/Nursery/Mathematics/MatchObjectWithNumber";
import MatchShapesWithObjects from "../../components/Nursery/Mathematics/MatchShapesWithObjects";
import MissingNumber from "../../components/Nursery/Mathematics/MissingNumber";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/nursery/mathematics/circle-correct-number", title: "Circle Correct Number", component: CircleCorrectNumber },
    { url: "/nursery/mathematics/count-object", title: "Count Object", component: CountObject},
    { url: "/nursery/mathematics/match-object-with-number", title: "Match Object With Number", component: MatchObjectWithNumber},
    { url: "/nursery/mathematics/missing-number", title: "Missing Number", component: MissingNumber},
    { url: "/nursery/mathematics/before-after-between-number", title: "Before / After / Between Numbers", component: BeforeAfterBetweenNumbers},
    { url: "/nursery/mathematics/match-shapes-with-object", title: "Match Shapes With Object", component: MatchShapesWithObjects},
    { url: "/nursery/mathematics/bigger-or-smaller", title: "Bigger or Smaller", component: CircleLargerObject},
];


export default topics;